import {theme} from "./Tema";


export const ESTADOANUNCIOS = [
    {
        nombre: 'Publicado',
        color: '#96172A'
    },
    {
        nombre: 'Archivado',
        color: '#00000080'
    },

]


export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]
